module.exports = __webpack_public_path__ + "static/media/recruit-background.6bbd5b57.png";